<template>
  <v-dialog v-model="this.$store.state.authVar.signUp" persistent max-width="500px">
    <v-card class="auth-card">
      <v-card-title>
        <span class="headline">{{ $t('auth.reg') }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeSignUp" v-if="this.$store.state.userData.socialFrom === 'local'">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex xs12 v-if="emailBar">
              <v-text-field
                  :label="$t('auth.mail')"
                  type="email"
                  prepend-icon="email"
                  required v-model="credentials.email" :rules="rules">
              </v-text-field>
            </v-flex>
            <v-flex d-flex xs12 sm6 v-if="this.$store.state.userData.socialFrom === 'local'">
              <v-text-field
                  :label="$t('auth.pass')"
                  type="password"
                  prepend-icon="lock"
                  required v-model="credentials.password" :rules="rules">
              </v-text-field>
            </v-flex>
            <v-flex d-flex xs12 sm6 v-if="this.$store.state.userData.socialFrom === 'local'">
              <v-text-field
                  :label="$t('auth.repass')"
                  type="password"
                  prepend-icon="lock"
                  required v-model="credentials.password2" :rules="rules"></v-text-field>
            </v-flex>
            <v-flex d-flex xs12 sm6 v-if="firstBar">
              <v-text-field
                  prepend-icon="person"
                  :label="$t('auth.name')"
                  required
                  v-model="credentials.firstName"
                  :rules="rules"
              ></v-text-field>
            </v-flex>
            <v-flex d-flex xs12 sm6 v-if="lastBar">
              <v-text-field
                  prepend-icon="person"
                  :label="$t('auth.surname')"
                  required
                  v-model="credentials.lastName"
                  :rules="rules"
              ></v-text-field>
            </v-flex>
            <v-flex d-flex xs12 sm6>

              <v-dialog
                  ref="dialog"
                  v-model="menu"
                  :return-value.sync="credentials.birthDate"
                  persistent
                  lazy
                  full-width
                  width="290px"
              >
                <v-text-field
                    slot="activator"
                    v-model="credentials.birthDate"
                    :label="$t('auth.birthDate')"
                    prepend-icon="event"
                    readonly
                    :rules="rules"
                ></v-text-field>
                <v-date-picker
                    ref="picker"
                    v-model="credentials.birthDate"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1900-01-01"
                    :locale="$t('auth.datePicker')"
                >
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="$refs.dialog.save(credentials.birthDate)">OK</v-btn>
                </v-date-picker>
              </v-dialog>

            </v-flex>
            <v-flex d-flex xs12 sm6>
              <v-text-field
                  label="069-00-00-00"
                  prepend-icon="phone"
                  mask="###-##-##-##"
                  single-line
                  v-model="credentials.phone"
                  :rules="rules"
              ></v-text-field>
            </v-flex>
            <v-flex d-flex>
              <label>
                <input type="checkbox" v-model="credentials.agree" required>
                <span v-html="$t('auth.agreeText')" class="ml-3"></span>
              </label>
            </v-flex>
            <v-flex d-flex xs12 mt-3>
              <v-btn block color="primary" @click="performSignUp" :loading="loading" :disabled="loading || !credentials.agree">
                {{ $t('auth.confirm') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import UserFunc from '@/components/partials/AuthForm'

export default {
  name: 'RegModal',
  components: {
    UserFunc
  },
  data () {
    return {
      menu: false,
      rules: [(value) => !!value || this.$t('auth.required')],
      loading: false,
      credentials: {
        email: null,
        password: null,
        password2: null,
        firstName: null,
        lastName: null,
        birthDate: null,
        phone: null
      }
    }
  },
  watch: {
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  methods: {
    closeSignUp () {
      this.$store.commit('var', {type: 'authVar', i: 'signUp', v: false})
    },
    performSignUp () {
      if (this.$store.state.userData.socialFrom === 'local') {
        UserFunc.userSignUp(this, this.credentials)
      } else {
        UserFunc.updateSocial(this, this.credentials)
      }
    },
    save (date) {
      this.$refs.menu.save(date)
    }
  },
  computed: {
    emailBar: function () {
      return !(this.$store.state.userData.email && this.$store.state.userData.socialFrom !== 'local')
    },
    firstBar: function () {
      return !(this.$store.state.userData.firstName && this.$store.state.userData.socialFrom !== 'local')
    },
    lastBar: function () {
      return !(this.$store.state.userData.lastName && this.$store.state.userData.socialFrom !== 'local')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/partials/AuthForm/RegModal.vue